import validate from 'validate.js'
import firebase from 'firebase/app'
import 'firebase/auth'
import { useTEPopupsFunctions } from 'react-tec'

interface Data {
	email: string
	popupFunctions: useTEPopupsFunctions
}
export const sendForgotPasswordEmail = async (data: Data) => {
	const { email, popupFunctions } = data
	const { showAlert, showNetworkActivity, hideNetworkActivity } = popupFunctions

	//Validate Data
	const validatorConstraints: { [key: string]: any } = {
		email: {
			presence: {
				allowEmpty: false,
			},
			email: true,
		},
	}
	const validationResponse = validate(data, validatorConstraints)
	if (validationResponse) {
		const valuesArray: any[][] = Object.values(validationResponse)
		const firstError: any[] = valuesArray[0]
		const firstErrorMessage: string = firstError[0]
		showAlert({
			title: 'Error',
			message: firstErrorMessage,
		})
		throw new Error(firstErrorMessage)
	}

	try {
		showNetworkActivity('Sending Forgot Password Email...')
		await firebase.auth().sendPasswordResetEmail(email)
		hideNetworkActivity()
		showAlert({
			title: 'Success',
			message:
				'An email has been sent to the provided address. Follow the instructions in the email to reset your password.',
		})
		return
	} catch (e) {
		console.log(e)
		hideNetworkActivity()
		showAlert({
			title: 'Error',
			message: 'Error sending forgot password email.',
		})
		throw new Error(e as any)
	}
}
